/**
 * API Configuration
 * 
 * Centralized configuration for API base URL.
 * Uses environment variables for easy configuration across environments.
 * 
 * Environment Variables:
 * - VUE_APP_API_BASE_URL: Base URL for the API (default: http://127.0.0.1:8080)
 * 
 * Usage:
 *   import { API_BASE_URL } from '@/config/api';
 *   const response = await fetch(`${API_BASE_URL}/auth/signup`, {...});
 */

/**
 * API Base URL
 * Reads from environment variable VUE_APP_API_BASE_URL
 * Falls back to development URL if not set
 * 
 * @type {string}
 */
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8080';

/**
 * Helper function to build full API URL
 * 
 * @param {string} endpoint - API endpoint (e.g., '/auth/signup')
 * @returns {string} Full URL
 * 
 * @example
 *   buildApiUrl('/auth/signup') // => 'http://127.0.0.1:8080/auth/signup'
 *   buildApiUrl('auth/signup')  // => 'http://127.0.0.1:8080/auth/signup'
 */
export function buildApiUrl(endpoint) {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${cleanEndpoint}`;
}

/**
 * API Configuration Object
 * Contains all API-related configuration
 */
export default {
  baseURL: API_BASE_URL,
  buildUrl: buildApiUrl,
};
